import { STATUS_COLORS } from "../../utils/constant";
import { getStatusDotColor } from "../../utils/constant";

const StatusBadge = ({ status }) => {
  if (!status) return <span className="status-badge">—</span>;
  const normalizedStatus = status.toLowerCase();
  const color =
    STATUS_COLORS[status] ||
    getStatusDotColor(normalizedStatus) ||
    STATUS_COLORS.Default;

  return (
    <span
      className="status-badge"
      style={{
        backgroundColor: color,
      }}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
